var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSuperadmin)?_c('div',{staticClass:"d-flex align-center",staticStyle:{"gap":"1rem"}},[_c('div',{staticStyle:{"font-size":"14px"}},[_vm._v(" Alle abschliessen ")]),_c('v-switch',{attrs:{"inset":"","dense":""},model:{value:(_vm.allCompleted),callback:function ($$v) {_vm.allCompleted=$$v},expression:"allCompleted"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }